import { useEffect } from "react";

const useFocusTrap = (isOpen, trappedRef, buttonId) => {
	const selectorString = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])";

	useEffect(() => {
		if (isOpen) {
			// Focus the first focusable element when the module opens
			const firstFocusableElement = trappedRef.current.querySelector(selectorString);
			if (buttonId && firstFocusableElement) {
				firstFocusableElement.focus();
			}

			// Trap focus within the module
			const handleKeyDown = (event) => {
				if (event.key !== "Tab") return;

				const focusableElements = trappedRef.current.querySelectorAll(selectorString);
				const firstFocusable = document.querySelector(`#${buttonId}`) || focusableElements[0];
				const lastFocusable = focusableElements[focusableElements.length - 1];

				if (
					(!event.shiftKey && document.activeElement === lastFocusable)
					|| (event.shiftKey && document.activeElement === firstFocusableElement)
				) {
					// If not shift key and focused element is last, focus first
					event.preventDefault();
					firstFocusable.focus();
				} else if (document.activeElement === firstFocusable) {
					const elementToFocus = event.shiftKey ? lastFocusable : firstFocusableElement;
					elementToFocus.focus();
				}
			};

			document.addEventListener("keydown", handleKeyDown);

			return () => {
				document.removeEventListener("keydown", handleKeyDown);
			};
		}
	}, [isOpen, trappedRef]);
};

export default useFocusTrap;
